import React from 'react';
import { FiMenu } from 'react-icons/fi';

const Header = ({ onMenuClick, showMenuButton = false }) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-30">
      <div className="flex items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
        {/* Left side */}
        <div className="flex items-center">
          {showMenuButton && (
            <button
              onClick={onMenuClick}
              className="mr-4 p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Abrir menú de navegación"
            >
              <FiMenu className="h-6 w-6" aria-hidden="true" />
            </button>
          )}

          <div className="flex items-center">
            <h1 className="text-xl font-semibold text-gray-900">
              Teonila HouseKeeping Management
            </h1>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;